module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "u-force-3d u-relative u-fit-w u-pad-y-sm c-matches-table-row u-pad-a-1 u-overflow-h",
    class: ['c-matches-table-row--' + _vm._getStatus(), _vm._getLive() ? 'c-matches-table-row--live' : 'c-matches-table-row--not-live']
  }, [_c('td', {
    staticClass: "u-align-center u-hide@md u-w1of3 u-w3of10@lg"
  }, [_c('div', {
    staticClass: "u-inline-block u-valign-middle"
  }, [_c('img', {
    staticClass: "c-matches-table-row__team-logo u-opacity--4 u-valign-middle",
    attrs: {
      "src": _vm.teamA.logotype,
      "alt": _vm.teamA.name,
      "title": _vm.teamA.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-middle u-pad-l-xs t-text--md u-align-left"
  }, [_c('p', {
    staticClass: "u-uppercase t-text--bold t-text--xxxl u-line-height--sm"
  }, [_vm._v(_vm._s(_vm.teamA.accronym))]), _vm._v(" "), _c('p', {
    staticClass: "u-uppercase t-text--sm t-lspacing--sm u-opacity--4"
  }, [_vm._v(_vm._s(_vm.teamA.name))])])]), _vm._v(" "), _c('td', {
    staticClass: "u-hide@md"
  }, [_c('div', {
    staticClass: "u-marg-y-md"
  }, [_c('app-matches-table-counter', {
    staticClass: "u-marg-b-xs",
    attrs: {
      "content-global": _vm.contentGlobal,
      "match": _vm.match
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-align-center u-marg-b-xxxs"
  }, [_c('router-link', {
    staticClass: "t-text--sm u-color--red-pure u-uppercase u-bold u-relative u-click-area--xxs",
    attrs: {
      "to": _vm._getLink()
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomy.details)
    }
  }), _vm._v(" "), _c('app-arrow-link')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "u-align-center u-uppercase t-text--sm t-lspacing--md u-opacity--4"
  }, [_c('span', {
    staticClass: "u-marg-t-xxxs",
    domProps: {
      "innerHTML": _vm._s(_vm._getDateFormatted(_vm.match.dateStart))
    }
  }), _vm._v(" -\n                "), _c('span', {
    staticClass: "t-text--xxs u-valign-middle",
    domProps: {
      "innerHTML": _vm._s(_vm.match.dateInfo)
    }
  })])], 1)]), _vm._v(" "), _c('td', {
    staticClass: "u-align-center u-hide@md u-w1of3 u-w3of10@lg"
  }, [_c('div', {
    staticClass: "u-inline-block u-valign-middle u-pad-r-xs t-text--md u-align-right"
  }, [_c('p', {
    staticClass: "u-uppercase t-text--bold t-text--xxxl"
  }, [_vm._v(_vm._s(_vm.teamB.accronym))]), _vm._v(" "), _c('p', {
    staticClass: "u-uppercase t-text--sm u-opacity--4"
  }, [_vm._v(_vm._s(_vm.teamB.name))])]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-valign-middle"
  }, [_c('img', {
    staticClass: "c-matches-table-row__team-logo u-opacity--4 u-valign-middle u-grayscale",
    attrs: {
      "src": _vm.teamB.logotype,
      "alt": _vm.teamB.name,
      "title": _vm.teamB.name
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "u-hide u-align-center u-block@md"
  }, [_c('div', {
    staticClass: "u-flex--x u-marg-b-md u-marg-t-lg"
  }, [_c('div', {
    staticClass: "u-fit-w"
  }, [_c('span', {
    staticClass: "u-block u-valign-middle t-text--xxxl t-text--bold u-color--gray u-marg-b-xs"
  }, [_vm._v(_vm._s(_vm.match.teamOneScore))]), _vm._v(" "), _c('div', {
    staticClass: "u-block u-valign-middle"
  }, [_c('img', {
    staticClass: "c-matches-table-row__team-logo--phone u-opacity--4 u-valign-middle u-marg-b-xs",
    attrs: {
      "src": _vm.teamA.logotype,
      "alt": _vm.teamA.name,
      "title": _vm.teamA.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-block u-valign-middle t-text--md"
  }, [_c('p', {
    staticClass: "u-block u-uppercase t-text--bold t-text--xxxl u-marg-b-xxxs u-line-height--sm"
  }, [_vm._v(_vm._s(_vm.teamA.accronym))]), _vm._v(" "), _c('p', {
    staticClass: "u-block u-uppercase t-text--md t-lspacing--sm u-opacity--4"
  }, [_vm._v(_vm._s(_vm.teamA.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "u-fit-w"
  }, [_c('span', {
    staticClass: "u-block u-valign-middle t-text--xxxl t-text--bold u-color--gray u-marg-b-xs"
  }, [_vm._v(_vm._s(_vm.match.teamTwoScore))]), _vm._v(" "), _c('div', {
    staticClass: "u-block u-valign-middle"
  }, [_c('img', {
    staticClass: "c-matches-table-row__team-logo--phone u-opacity--4 u-valign-middle u-marg-b-xs",
    attrs: {
      "src": _vm.teamB.logotype,
      "alt": _vm.teamB.name,
      "title": _vm.teamB.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-block u-valign-middle t-text--md"
  }, [_c('p', {
    staticClass: "u-block u-uppercase t-text--bold t-text--xxxl u-marg-b-xxxs u-line-height--sm"
  }, [_vm._v(_vm._s(_vm.teamB.accronym))]), _vm._v(" "), _c('p', {
    staticClass: "u-block u-uppercase t-text--md t-lspacing--sm u-opacity--4"
  }, [_vm._v(_vm._s(_vm.teamB.name))])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "u-align-center u-uppercase t-text--md t-lspacing--md u-line-height--sm u-color--gray-blue u-opacity--7 u-marg-b-sm"
  }, [_c('span', {
    staticClass: "u-align-center u-block",
    domProps: {
      "innerHTML": _vm._s(_vm.match.league)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-marg-t-xxxs u-block",
    domProps: {
      "innerHTML": _vm._s(_vm._getDateFormatted(_vm.match.dateStart))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-align-center u-marg-b-lg"
  }, [_c('router-link', {
    staticClass: "t-text--md u-color--red-pure u-uppercase u-bold u-relative u-click-area--xxs",
    attrs: {
      "to": _vm._getLink()
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomy.details)
    }
  }), _vm._v(" "), _c('app-arrow-link')], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f3f8a5c"}!./src/scripts/components/app-matches-table-tr/template.html
// module id = 916
// module chunks = 0